import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';

// Single locale (en) shipped today; the resources/fallback structure is
// what lets additional locales be added later without touching call
// sites — every page reads strings via t('namespace.key'), never a
// literal, so adding e.g. es.json and registering it below is the only
// change needed to support a new language.
i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, // React already escapes
  },
});

export default i18n;
